(function() {
  'use strict';

  function bindRecDropdowns() {
    var listEl = document.getElementById('alohr-recs-list');
    if (!listEl) return;

    listEl.querySelectorAll('.alohr-rec__select-display').forEach(function(disp) {
      if (disp._recBound) return;
      disp._recBound = true;
      // touchstart preventDefault stops scroll interference and makes iOS fire click immediately
      disp.addEventListener('touchstart', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
      disp.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = disp.closest('.alohr-rec__select-wrap');
        var opts = wrap && wrap.querySelector('[data-rec-select-options]');
        if (!opts) return;
        document.querySelectorAll('.alohr-rec__select-options.is-open').forEach(function(o) {
          if (o !== opts) o.classList.remove('is-open');
        });
        opts.classList.toggle('is-open');
      });
    });

    listEl.querySelectorAll('.alohr-rec__select-option').forEach(function(opt) {
      if (opt._recBound) return;
      opt._recBound = true;
      opt.addEventListener('touchstart', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
      opt.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (opt.dataset.oos === '1') return;
        var card = opt.closest('.alohr-rec');
        if (!card) return;
        var wrap = opt.closest('.alohr-rec__select-wrap');
        var disp = wrap && wrap.querySelector('[data-rec-select-display]');
        var opts = wrap && wrap.querySelector('[data-rec-select-options]');
        var vid = parseInt(opt.dataset.vid, 10);
        card.dataset.selectedVid = vid ? String(vid) : '';
        if (disp) { disp.textContent = opt.textContent; disp.classList.remove('is-placeholder'); }
        if (opts) opts.classList.remove('is-open');
        var btn = card.querySelector('[data-action="add-rec-selected"]');
        if (btn) btn.disabled = false;
      });
    });
  }

  function watchRecs() {
    var list = document.getElementById('alohr-recs-list');
    if (!list) { setTimeout(watchRecs, 400); return; }
    var obs = new MutationObserver(function() { setTimeout(bindRecDropdowns, 60); });
    obs.observe(list, { childList: true });
    bindRecDropdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRecs);
  } else {
    watchRecs();
  }
})();
